import Cookies from 'js-cookie'
import CryptoJS from 'crypto-js'
import { isNotEmpty, objNotEmpty } from '../utils/helpers'

const COOKIE_DEFAULT_META = { path: '/', domain: `${process.env.REACT_APP_DOMAIN}`, expires: 3 }
const encryptionKeyParsed = CryptoJS.enc.Utf8.parse('g4^D^bv&rn3SJzakRw9#%gZX9*tuV!Cg')
const ivParsed = CryptoJS.enc.Utf8.parse('R6C*%LLxhrdL3kLt');
const cfg = {
  iv: ivParsed,
  padding: CryptoJS.pad.Pkcs7,
  mode: CryptoJS.mode.CBC,
};

const CookiesStorageService = (() => {
  let _service

  function _getService() {
    if (!_service) {
      _service = this
      return _service
    }
    return _service
  }

  function _encryptData(dataToEncrypt) {
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(dataToEncrypt), encryptionKeyParsed, cfg)
    const encryptedStr = encrypted.toString()
    return encodeURIComponent(encryptedStr)
  }

  function _decryptData() {
    if (isNotEmpty(Cookies.get('ud'))) {
      const userData = decodeURIComponent(Cookies.get('ud'))
      const decrypted = CryptoJS.AES.decrypt(userData, encryptionKeyParsed, cfg)
        .toString(CryptoJS.enc.Utf8);

      return JSON.parse(decrypted) || { }
    }
    return { }
  }

  function _setUserData(userData) {
    if (objNotEmpty(userData)) {
      const encryptedId = _encryptData(userData)
      Cookies.set('ud', encryptedId, COOKIE_DEFAULT_META)
      _setUserLanguage(userData?.language)
    }
  }

  function _getAccessToken() {
    const { token } = _decryptData()
    return token
  }

  function _getAccessRefreshToken() {
    const { refresh_token } = _decryptData()
    return refresh_token
  }

  function _getUserId() {
    const { user_id } = _decryptData()
    return user_id
  }

  function _getEmployeeId() {
    const { employee_id } = _decryptData()
    return employee_id
  }

  function _getUserName() {
    const { name } = _decryptData()
    return name
  }

  function _getUserEmail() {
    const { email } = _decryptData()
    return email
  }

  function _getUserModules() {
    const { modules } = _decryptData()
    return modules
  }

  function _getAdminType() {
    const { admin_type } = _decryptData()
    return admin_type
  }

  function _getIntegrationType() {
    const { user_integration_type } = _decryptData()
    return user_integration_type
  }

  function _getEdsRoles() {
    const { eds_roles } = _decryptData()
    return eds_roles
  }
  function _getSelfRoles() {
    const { self_roles, demo_roles } = _decryptData()
    const normalizedSelfRoles = Array.isArray(self_roles) ? [...self_roles] : []
    const normalizedDemoRoles = Array.isArray(demo_roles) ? [...demo_roles] : []

    normalizedSelfRoles?.sort((a, b) => b?.localeCompare(a))
    normalizedDemoRoles?.sort((a, b) => b?.localeCompare(a))

    return [...normalizedSelfRoles, ...normalizedDemoRoles]
  }

  function _getRecRoles() {
    const { rec_roles } = _decryptData()
    return rec_roles
  }

  function _getFabsRoles() {
    const { fabs_roles } = _decryptData()
    return fabs_roles
  }

  function _getIsFirstLogin() {
    const { password_reset_required } = _decryptData()
    return password_reset_required
  }

  function _clearCookies() {
    Cookies.remove('ud', COOKIE_DEFAULT_META)
    Cookies.remove('language', COOKIE_DEFAULT_META)
  }

  function _getUserLanguage() {
    const { language } = _decryptData()
    const cookiesLang = Cookies.get('language')
    let curLang = language

    if (cookiesLang?.toLowerCase() !== language?.toLowerCase()) {
      curLang = cookiesLang
    }

    return curLang
  }

  function _setUserLanguage(language) {
    Cookies.set('language', language, { path: '/', domain: `${process.env.REACT_APP_DOMAIN}` })
  }

  function _getTenantId() {
    const { tenant_id } = _decryptData()
    return tenant_id
  }

  function _getIsSamlUser() {
    const { saml_user } = _decryptData()
    return saml_user
  }

  function _getSubscriptionReminder() {
    const { subscription_reminder } = _decryptData()
    return subscription_reminder
  }

  function _isAcceptedPolicies() {
    const { accepted_policies } = _decryptData()
    return accepted_policies === null ? true : Boolean(accepted_policies)
  }

  function _setAcceptedPolicies(value) {
    const userData = _decryptData()
    if (objNotEmpty(userData)) {
      const encryptedId = _encryptData({ ...userData, accepted_policies: value })
      Cookies.set('ud', encryptedId, COOKIE_DEFAULT_META)
    }
  }
  return {
    getService: _getService,
    setUserData: _setUserData,
    getAccessToken: _getAccessToken,
    getAccessRefreshToken: _getAccessRefreshToken,
    getUserId: _getUserId,
    getEmployeeId: _getEmployeeId,
    getUserName: _getUserName,
    getUserEmail: _getUserEmail,
    getUserModules: _getUserModules,
    getAdminType: _getAdminType,
    getIntegrationType: _getIntegrationType,
    getEdsRoles: _getEdsRoles,
    getSelfRoles: _getSelfRoles,
    getRecRoles: _getRecRoles,
    getFabsRoles: _getFabsRoles,
    clearCookies: _clearCookies,
    getIsFirstLogin: _getIsFirstLogin,
    getUserLanguage: _getUserLanguage,
    setUserLanguage: _setUserLanguage,
    getTenantId: _getTenantId,
    getIsSamlUser: _getIsSamlUser,
    getSubscriptionReminder: _getSubscriptionReminder,
    isAcceptedPolicies: _isAcceptedPolicies,
    setAcceptedPolicies: _setAcceptedPolicies,
  }
})()

export default CookiesStorageService
